import React from 'react';

import {QuestionCircleFilled} from '@ant-design/icons/lib';
import {Tooltip} from 'antd';
import type {TooltipProps} from 'antd/es/tooltip';
import styled from 'styled-components';

import {colors} from 'lib/colors';

interface IProps extends Omit<TooltipProps, 'title'> {
  message?: TooltipProps['title'];
  title?: TooltipProps['title'];
  icon?: React.JSX.Element | null;
}

// eslint-disable-next-line react-refresh/only-export-components
export const HintIcon = styled(QuestionCircleFilled)`
  color: ${colors.secondary};
  opacity: 0.3;
`;

export const Hint: React.FC<IProps> = ({
  message,
  title,
  icon = <HintIcon />,
  children,
  ...props
}) => {
  const content = title || children || null;
  if (!message) return <>{content}</>;

  // Handle RenderFunction case for content
  const renderContent = typeof content === 'function' ? content() : content;

  return (
    <Tooltip title={message} {...props}>
      {renderContent ? (
        icon ? (
          <span>
            {renderContent} <>{icon}</>
          </span>
        ) : (
          <>{renderContent}</>
        )
      ) : (
        <>{icon}</>
      )}
    </Tooltip>
  );
};
